import { makeModule } from "@/store/utils"
import { make } from "vuex-pathify"
import { asSequence } from "sequency"

const state = {
	rawPermissions: null,
};

const getters = {
	...make.getters(state),
	hasPermissions(state){
		return !!state.rawPermissions;
	},
	permissions(state){
		if(!getters.hasPermissions(state))
			return new Set([]);

		const permissions = asSequence(state.rawPermissions)
							.distinct()
							.toArray();

		return new Set(permissions);
	},
	can(state){
		return slug => getters.permissions(state).has(slug);
	},
};

const mutations = {
	...make.mutations(state),
};

const actions = {
	...make.actions(state),
	async FETCH_PERMISSIONS({ commit, getters }, { vm }){
		if(getters.hasPermissions)
			return;

		const perms = await vm.$json.get("/api/permissions");
		commit("SET_RAW_PERMISSIONS", perms);
	},
};

export default makeModule({
	state,
	getters,
	mutations,
	actions,
})